/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IAnchoredCategorySeriesInteractionManager_$type } from "./IAnchoredCategorySeriesInteractionManager";
import { Rect } from "igniteui-react-core";
import { ScalerParams } from "./ScalerParams";
import { truncate, intDivide, isNaN_ } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
/**
 * @hidden
 */
var AnchoredCategorySeriesInteractionManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AnchoredCategorySeriesInteractionManager, _super);
    function AnchoredCategorySeriesInteractionManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnchoredCategorySeriesInteractionManager.prototype.c$b = function (a, b, c, d, e, f, g, h) {
        if (!g) {
            return h(b);
        }
        if (e == null || e.cm || f == null || d == null || isNaN_(b.x) || isNaN_(b.y)) {
            return h(b);
        }
        if (c <= 1) {
            return h(b);
        }
        var i = truncate(Math.round(a.f7(b)));
        if (i < 0 || i >= a.ck.count) {
            return h(b);
        }
        var j = intDivide(i, c);
        var k = c * j;
        var l = Math.min(k + c, d.count - 1);
        var m = a.pv(a.b0);
        var n = new ScalerParams(0, a.cd.tp, a.cd.to, f.cg, a.cd.td);
        var o = m.top;
        var p = m.bottom;
        var q = o + (p - o) * b.y;
        var r = f.el(q, n);
        var s = 1.7976931348623157E+308;
        var t = k;
        for (var u = k; u <= l; u++) {
            var v = Math.abs(d.item(u) - r);
            if (v < s) {
                s = v;
                t = u;
            }
        }
        return a.ck.item(t);
    };
    AnchoredCategorySeriesInteractionManager.prototype.c$a = function (a, b, c, d, e, f) {
        var g = a.b0.bv;
        g = g.copy();
        var h = a.b0.bu;
        var i = new Rect(0, 0, 0, 1, 1);
        var j = !g.isEmpty && !h.isEmpty && a.ck != null ? a.ck.indexOf(f) : -1;
        var k = a.px(a.b0);
        var l = new ScalerParams(0, i, i, c.cg, k);
        var m = new ScalerParams(0, i, i, d.cg, k);
        m.b = a.ge();
        var n = c != null ? c.ei(j, l) : NaN;
        n += e;
        var o = d != null && b != null && j < b.count ? d.ei(b.item(j), m) : NaN;
        if (!isNaN_(n)) {
            if (n < g.left + 0.1 * g.width) {
                n = n + 0.4 * g.width;
                g.x = n - 0.5 * g.width;
            }
            if (n > g.right - 0.1 * g.width) {
                n = n - 0.4 * g.width;
                g.x = n - 0.5 * g.width;
            }
        }
        if (!isNaN_(o)) {
            if (o < g.top + 0.1 * g.height) {
                o = o + 0.4 * g.height;
                g.y = o - 0.5 * g.height;
            }
            if (o > g.bottom - 0.1 * g.height) {
                o = o - 0.4 * g.height;
                g.y = o - 0.5 * g.height;
            }
        }
        if (a.b8 != null) {
            a.b8.au(a.cd, g, true);
        }
        return j >= 0;
    };
    AnchoredCategorySeriesInteractionManager.prototype.c$c = function (a, b) {
        var c = "<div class='ui-chart-default-tooltip-content'>";
        var d = null;
        d = a.ar();
        if (d.cd) {
            var e = d;
            c += "<span>${item." + e.dateTimeMemberPath + "}</span><br/>";
        }
        else if (d != null && d.fz != null) {
            c += "<span>${item." + d.fz.toString() + "}</span><br/>";
        }
        c += "<span";
        var f = a.a6.a$r(a);
        if (!stringIsNullOrEmpty(f)) {
            c += " style='color:" + f + "'";
        }
        c += ">${series.title}: </span><span class='ui-priority-primary'>" + "${item." + b + "}</span></div>";
        return c;
    };
    AnchoredCategorySeriesInteractionManager.prototype.c$d = function (a, b, c, d, e, f, g, h) {
        if (c == null || d == null) {
            return Rect.empty;
        }
        var i = a.pl(b);
        var j = a.b0.bv;
        var k = a.b0.bu;
        var l = a.getEffectiveViewport1(a.b0);
        var m = new ScalerParams(0, j, k, d.cg, l);
        m.b = a.ge();
        var n = a.aj(a.ar(), e.f, f, g, b, true);
        if (n == null) {
            return Rect.empty;
        }
        var o = n[0];
        var p = n[1];
        var q = Math.abs(i.x - o[0]);
        var r = Math.abs(i.x - p[0]);
        var s = d.ei(d.l5, m);
        var t = c.k3(j, k, l);
        if (q < r) {
            var u = o[0] - 0.5 * t;
            var v = h(o);
            var w = s;
            return new Rect(0, u, Math.min(v, w), t, Math.max(v, w) - Math.min(v, w));
        }
        else {
            var x = p[0] - 0.5 * t;
            var y = h(p);
            var z = s;
            return new Rect(0, x, Math.min(y, z), t, Math.max(y, z) - Math.min(y, z));
        }
    };
    AnchoredCategorySeriesInteractionManager.$t = markType(AnchoredCategorySeriesInteractionManager, 'AnchoredCategorySeriesInteractionManager', Base.$, [IAnchoredCategorySeriesInteractionManager_$type]);
    return AnchoredCategorySeriesInteractionManager;
}(Base));
export { AnchoredCategorySeriesInteractionManager };
